import SiteShell from '@/layouts/SiteShell'

import Router from './router'

function App() {
  return <SiteShell><Router /></SiteShell>
}

export default App
